/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_1_TitleInputs */

const et_portfolio_project_1_title = /** @type {(inputs: Portfolio_Project_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google top 3 90 päevaga – sissetulevad päringud kolmekordistusid.`)
};

const en_portfolio_project_1_title = /** @type {(inputs: Portfolio_Project_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranked top 3 on Google in 90 days - tripled inbound inquiries.`)
};

/**
* | output |
* | --- |
* | "Ranked top 3 on Google in 90 days - tripled inbound inquiries." |
*
* @param {Portfolio_Project_1_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_1_title = /** @type {((inputs?: Portfolio_Project_1_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_1_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_1_title(inputs)
	return en_portfolio_project_1_title(inputs)
});